module.exports = __webpack_public_path__ + "media/images/logos/horizontal-navy-pink-plinth-051a1a56bf432141380749b5ed46a010.svg";